module.exports = __webpack_public_path__ + "img/icon_1.18bcc2a0.png";